import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GoogleData } from '../../services/GoogleData/GoogleData';
import { Book } from '../../services/GoogleData/Book';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { Library } from '../../services/ShelvableBackend/Library';
import { Shelf } from '../../services/ShelvableBackend/Shelf';
import { Utilities } from '../../services/Utilities';
import { Analytics } from '../../services/Analytics';

import { NgbModal, NgbActiveModal } from '@mattlewis92/ng-bootstrap';

import { Observable } from 'rxjs'

@Component({
    selector: 'affiliate-info-modal',
    templateUrl: './affiliate-info-modal.html',
    encapsulation: ViewEncapsulation.None
})
export class AffiliateInfoModalComponent {
    constructor(public activeModal: NgbActiveModal) {}
}

@Component({
    selector: 'book-modal',
    templateUrl: './book-modal.html',
    styleUrls: ['./book-modal.css', './book-modal.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class BookModalComponent implements OnInit {
    @Input() googleId:string;
    @Input() fromScan:boolean = false;

    isLoading:boolean = true
    bookData:Book;
    isDone:any = {};
    makeArrayOfLength:(length:number) => any[] = Utilities.makeArrayOfLength;
    loggedInUserShelves:Observable<Shelf[]>;
    authState:any;
    linkBuilder:any;
    isLoggedIn:Observable<boolean>;
    
    facebookLikeUrl:SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    twitterTweetUrl:SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    goodreadsReviewUrl:SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    
    constructor(
        private googleData:GoogleData,
        private modalService: NgbModal,
        protected activeModal: NgbActiveModal,
        shelvableBackend:ShelvableBackend,
        private sanitizer:DomSanitizer) {
      
        this.loggedInUserShelves = shelvableBackend.loggedInUserShelves;
        this.authState = shelvableBackend.authState;
        this.linkBuilder = Utilities.linkBuilder;
        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
    }

    async ngOnInit() {
        this.bookData = await this.googleData.getBook(this.googleId);
        this.isLoading = false;   

        if (this.bookData.isbn) {
            this.goodreadsReviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.goodreads.com/api/reviews_widget_iframe?did=13526&amp;format=html&amp;header_text=&amp;isbn=' + Utilities.ISBN13to10(this.bookData.isbn) + '&amp;links=660&amp;num_reviews=4&amp;review_back=ffffff00&amp;stars=000000&amp;text=444');
        }

        if (GoogleData.validGoogleId.test(this.googleId)) {
            this.facebookLikeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facebook.com/v2.5/plugins/like.php?action=like&app_id=1456570911321600&href=' + encodeURIComponent('https://shelvable.com/b/' + this.googleId) + '&layout=button_count&locale=en_US&sdk=joey&share=false&show_faces=false');
            this.twitterTweetUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://platform.twitter.com/widgets/tweet_button.html?type=share&via=shelvable&url=' + encodeURIComponent('https://shelvable.com/b/' + this.googleId) + (this.bookData ? '&text=' + encodeURIComponent(this.bookData.title + ' by ' + (this.bookData.authors || []).join(', ')) : ''));
        } else {
            this.facebookLikeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facebook.com/v2.5/plugins/like.php?action=like&app_id=1456570911321600&href=' + encodeURIComponent('https://shelvable.com/') + '&layout=button_count&locale=en_US&sdk=joey&share=false&show_faces=false');
            this.twitterTweetUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://platform.twitter.com/widgets/tweet_button.html?type=share&via=shelvable&url=' + encodeURIComponent('https://shelvable.com/b/'));
        }
    }

    async showAffiliateInfoModal() {
        try {
            await this.modalService.open(AffiliateInfoModalComponent, {
                size: 'lg'
            }).result;
        } catch {
            console.log('Affiliate info modal closed')
        }
        
        Utilities.reAddModalOpen();
    };

    selecting:boolean = false;
    tabSelect = () => {
        this.selecting = !this.selecting;
    };

    trackPurchase() {
        Analytics.affiliateClick();
    }

    tabChange = (nextId:any) => {
        if (nextId === 'alsoByAuthor') this.loadAlsoByAuthor();
    }

    alsoByAuthorLoading:boolean = false;
    alsoByThisAuthor:any[] = [];
    maxBooksByAuthor:number = Number.MAX_SAFE_INTEGER;
    alsoByAuthorSearchComplete:boolean = false;

    async loadAlsoByAuthor() {
        if (!this.bookData || !this.bookData.authors || this.alsoByAuthorSearchComplete) {
            return;
        }
        this.alsoByAuthorLoading = true;
        var bookList = await this.googleData.getGoogleBooksList('author:"' + this.bookData.authors.join('" OR author:"') + '"', this.alsoByThisAuthor.length, 40);
        this.maxBooksByAuthor = bookList.totalItems;
        this.alsoByThisAuthor = this.alsoByThisAuthor.concat(bookList.books.filter(book => book.googleId !== this.googleId));
        this.alsoByAuthorLoading = false;
        this.alsoByAuthorSearchComplete = true;
    
    }
}


// WEBPACK FOOTER //
// ./web/static/components/book-modal/book-modal.ts